import { Id, Json, JsonEntity } from '@homeleite/arch';
import { Address, Contact } from '../common';
import { EMPTY } from '@homeleite/common-utils';

export class ProducerSummary implements JsonEntity {
    constructor(
        public readonly id = Id.gen(),
        public readonly name = EMPTY,
        public readonly code = EMPTY
    ) {}

    toJson() {
        return Json.to.simple(this);
    }

    static fromJson(json: any) {
        return Json.from.simple(json, ProducerSummary);
    }
}

export class Producer implements JsonEntity {
    constructor(
        public readonly id = Id.gen(),
        public name = EMPTY,
        public code = EMPTY,
        public addresses: Address[] = [],
        public contacts: Contact[] = []
    ) {}

    toJson() {
        return Json.to.simple(this, {
            addresses: Json.to.array(this.addresses),
            contacts: Json.to.array(this.contacts)
        });
    }

    static fromJson(json: any) {
        if (!json) return null as any;

        return Json.from.simple(json, Producer, {
            addresses: Json.from.array(json?.addresses, Address.fromJson),
            contacts: Json.from.array(json?.contacts, Contact.fromJson)
        });
    }
}
